import * as React from 'react';

import { AmplitudeMetadataContextProvider } from '../../support/amplitude/AmplitudeMetadataContext';

interface LabMetadataContextProps {
  trackId: string;
  trackSkippable: boolean;
  inviteId?: string;
  participantId: string;
  mode: string;
  teamSlug: string;
  children: React.ReactNode;
}

export const LabMetadataContext = ({ children, ...props }: Partial<LabMetadataContextProps>) => (
  <AmplitudeMetadataContextProvider metadata={props}>{children}</AmplitudeMetadataContextProvider>
);
